export default "__VITE_ASSET__25dcc642__"